import { render, staticRenderFns } from "./InventoriesTopSlot.vue?vue&type=template&id=9a17f16e"
import script from "./InventoriesTopSlot.vue?vue&type=script&lang=js"
export * from "./InventoriesTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports